import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "..";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const getContractModelCount = () => {
  return dispatch => {
    dispatch({ type: "GET_CONTRACT_MODEL_COUNT_LOADING" });
    api
      .contractModelCountGet()
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "FetchContractModelCountAlertTitle",
          "Virhe mallityösopimusten lukumäärän noutamisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_CONTRACT_MODEL_COUNT_SUCCEEDED",
  payload: { contractModelCount: data },
});

const operationFail = () => ({
  type: "GET_CONTRACT_MODEL_COUNT_FAIL",
});
